// import { getPost } from '@/request/system';
import {
    getUser,
    saveUser,
    getUserInfo,
    editUser,
    deleteUser,
    changeStatus,
    getUserInfoDetail,
    queryUserByCustomerId,
    getUserGroup,
    updateUserExpression,
    getUserTree,
    getUserListAll,
    updateUserBatch
} from '@/request/user';
import { ElMessage } from 'element-plus';

export default {
    namespace: true,

    state: {
        user: {
            count: 0,
            data: []
        },

        userInfo: {},

        post: {
            count: 0,
            postList: []
        },
        dept: {
            count: 0,
            deptList: []
        },
        role: {
            count: 0,
            roleList: []
        },
        userGroup: [],
        userTree: [],
        userList: []
        // userListAll: []
    },

    mutations: {
        SET_USER_LIST(state, user) {
            state.user = user;
        },

        SET_USER_INFO(state, userInfo) {
            state.userInfo = userInfo;
        },

        SET_POST_LIST(state, post) {
            state.post = post;
        },

        SET_DEPT_LIST(state, dept) {
            state.dept = dept;
        },

        SET_USER_GROUP(state, userGroup) {
            state.userGroup = userGroup;
        },

        SET_USER_LIST_TREE(state, userListTree) {
            state.userListTree = userListTree;
        },

        SET_USER_TREE(state, userTree) {
            let all = [{ nickname: '根节点', userId: -1 }, ...userTree];
            state.userTree = all;
        }

        // SET_USER_LIST_ALL(state,userListAll){
        //     state.userListAll = userListAll;
        // }
    },

    actions: {
        // 用户列表
        getUserList: async ({ commit }, payload) => {
            let res = await getUser(payload);
            if (res?.code == 200) {
                commit('SET_USER_LIST', res.data);
                return res;
            }
        },

        // 新增用户
        saveUser: async ({ dispatch }, payload) => {
            let res = await saveUser(payload);
            return res;
        },

        // 编辑用户
        editUser: async ({ dispatch }, payload) => {
            let res = await editUser(payload);
            return res;
        },
        // 用户详情
        getUserInfo: async ({ commit }) => {
            let res = await getUserInfo();
            if (res?.code == 200) {
                commit('SET_USER_INFO', res.data);
                return res;
            } else {
                commit('SET_USER_INFO', {});
            }
        },

        getUserInfoDetail: async ({}, payload) => {
            let res = await getUserInfoDetail(payload);
            return res;
        },

        getUserMenu: async () => {},

        // 用户删除
        deleteUser: async ({ commit, dispatch }, payload) => {
            let res = await deleteUser(payload);
            return res;
        },

        changeStatus: async ({ commit }, payload) => {
            let res = await changeStatus(payload);
            return res;
        },

        // getPostList: async ({ commit }, payload) => {
        //     let res = await getPost(payload);
        //     if (res.code == 200) {
        //         commit('SET_POST_LIST', res.data);
        //         return res;
        //     }
        // },

        // getDeptList: async ({ commit }, payload) => {
        //     let res = await getDept(payload);
        //     if (res.code == 200) {
        //         commit('SET_DEPT_LIST', res.data);
        //         return res;
        //     }
        // },

        getUserGroup: async ({ commit }, payload) => {
            let res = await getUserGroup(payload);
            if (res?.code == 200) {
                commit('SET_USER_GROUP', res.data);
            }
            return res;
        },

        updateUserExpression: async ({}, payload) => {
            let res = await updateUserExpression(payload);
            return res;
        },

        getUserTree: async ({ commit }, payload) => {
            let res = await getUserTree(payload);
            if (res?.code == 200) {
                commit('SET_USER_TREE', res.data ?? []);
            }
            return res;
        },

        getUserListTree: async ({ commit }, payload) => {
            let res = await getUserTree(payload);
            if (res?.code == 200) {
                commit('SET_USER_LIST_TREE', res.data ?? []);
            }
            return res;
        },

        updateUserBatch: async ({ commit }, payload) => {
            let res = await updateUserBatch(payload);
            return res;
        }

        // getUserListAll :async({commit},payload)=>{
        //     let res = await getUserListAll(payload);
        //     if(res?.code ==200){
        //         commit('',res.data??[])
        //     }
        // }
    }
};
